import React, { useState } from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import styles from "./DropdownButton.module.css";
import {
  Box,
  Divider,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { ReactComponent as ArrowDownIcon } from "../../assets/images/ArrowDown.svg";
import { styled } from "@mui/system";

export default function DropdownButton({
  alertData,
  handleListItemClick,
  selectedIndex,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        sx={buttonStyle}
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}
        disableElevation={true}
      >
        <Typography sx={buttonText}>
          Update
          <span className={styles.icon}>
            <ArrowDownIcon />
          </span>
        </Typography>
      </Button>
      <StyledPopover
        style={{ minWidth: "200px" }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box
          sx={{ width: "200px", maxWidth: 360, bgcolor: "background.paper" }}
        >
          <List component="nav" aria-label="secondary mailbox folder">
            {alertData?.length > 0 ? (
              alertData?.map((item, i) => (
                <>
                  <ListItemButton
                    selected={selectedIndex === 0}
                    onClick={() => handleListItemClick(item, i)}
                    style={{
                      backgroundColor: selectedIndex === i ? "#d9d9d9" : "",
                    }}
                  >
                    <ListItemText
                      primary={`${item?.translation?.transalationName} Translation`}
                    />
                  </ListItemButton>
                  <Divider sx={{ margin: "0px 12px" }} />
                </>
              ))
            ) : (
              <ListItemButton
                selected={selectedIndex === 0}
                style={{
                  color: "warning",
                }}
              >
                <ListItemText primary="Nothing to Update" />
              </ListItemButton>
            )}
          </List>
        </Box>
      </StyledPopover>
    </div>
  );
}

const StyledPopover = styled(Popover)(({ theme }) => ({
  "& .MuiPaper-root": {
    boxShadow: "none",
    border: "1px solid #e0e0e0",
    borderRadius: "4px",
  },
  "& .MuiListItemText-primary": {
    fontSize: "14px",
    letterSpacing: "-0.02em",
    fontWeight: 500,
    fontFamily: "Montserrat",
    color: "#5a5a5a",
    textAlign: "left",
  },
  "& .MuiList-root": {
    padding: 0,
  },
}));

const buttonStyle = {
  backgroundColor: "#fff",
  borderRadius: "4px",
  width: "auto",
  height: "48px",
  marginLeft: "auto",
  lineHeight: "40px",
  textAlign: "center",
  "&:hover": {
    backgroundColor: "#fff",
    border: "1px solid #f7954c",
  },
};

const buttonText = {
  fontSize: "16px",
  letterSpacing: "-0.02em",
  fontFamily: "Montserrat",
  color: "#f7954c",
  textAlign: "center",
  textTransform: "capitalize",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  lineHeight: "24px",
  fontWeight: 600,
  padding: "0 10px",
};
